import { adapter, CobrowsingSessions, initialCobrowsingSessions } from '@agent/core/store/cobrowsing/cobrowsing.model';
import { Action, createReducer, on } from '@ngrx/store';
import { CobrowsingAction } from '@agent/core/store/cobrowsing/cobrowsing.dispatcher';

const cobrowsingSessionsReducer = createReducer(
  initialCobrowsingSessions,
  on(CobrowsingAction.InitCobrowsing, (state, { info }) =>
    adapter.upsertOne(
      {
        ...info,
      },
      state
    )
  ),
  on(CobrowsingAction.CobrowsingStarted, (state, { info }) =>
    adapter.updateOne(
      {
        id: info.bookingId,
        changes: {
          sessionCode: info.sessionCode,
          sessionId: info.sessionId,
        },
      },
      state
    )
  ),
  on(CobrowsingAction.CobrowsingSessionUpdated, (state, { info }) =>
    adapter.updateOne(
      {
        id: info.bookingId,
        changes: {
          sessionState: info.sessionState,
          errorMessageKey: info.errorMessageKey,
        },
      },
      state
    )
  ),
  on(CobrowsingAction.CobrowsingEnded, (state, { bookingId }) =>
    adapter.updateOne(
      {
        id: bookingId,
        changes: {
          sessionCode: undefined,
          sessionId: undefined,
          sessionState: undefined,
        },
      },
      state
    )
  ),
  on(CobrowsingAction.RemoveCobrowsing, (state, { bookingId }) => adapter.removeOne(bookingId, state))
);

export function reducer(state: CobrowsingSessions | undefined, action: Action) {
  return cobrowsingSessionsReducer(state, action);
}
